import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LicenceTypeDto } from '../dtos/dtos';

@Injectable({
  providedIn: 'root',
})
export class LicenceTypeService {
  private url = `${environment.apiUrl}/admin/licence-types`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<LicenceTypeDto[]> {
    return this.http.get<LicenceTypeDto[]>(this.url);
  }
}
